import type { ProductPaymentRequest } from 'routes/tourOperator/bookings/types/productTransactionInfoTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import FetchingStatus from 'constants/statuses/FetchingStatus';

export type ProductPaymentState = {
  fetching: FetchingStatus | null;
  result: ProductPaymentRequest | null;
};

const initialState: ProductPaymentState = {
  fetching: null,
  result: null,
};

function setFetchingFunction(state: ProductPaymentState, action: PayloadAction<ProductPaymentState['fetching']>) {
  return {
    ...state,
    fetching: action.payload,
  };
}

function setResultFunction(state: ProductPaymentState, action: PayloadAction<ProductPaymentState['result']>) {
  return {
    ...state,
    result: action.payload,
  };
}

const slice = createSlice({
  name: 'productPayment',
  initialState,
  reducers: {
    setFetching: setFetchingFunction,
    setResult: setResultFunction,
  },
});

export const { setFetching, setResult } = slice.actions;
export default slice.reducer;
